'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
/*tslint:disable */
var Code = function Code(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 24 24' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M14.725 4.228c.17.051.298.153.38.3.085.15.102.317.052.48l-4.385 15.178a.632.632 0 0 1-.298.373.568.568 0 0 1-.465.053l-.736-.202a.63.63 0 0 1-.373-.298.599.599 0 0 1-.052-.48l4.385-15.178a.631.631 0 0 1 .298-.373.569.569 0 0 1 .465-.053l.729.2zM2.707 12.32l4.442 4.443a.62.62 0 0 1 0 .894l-.587.587a.62.62 0 0 1-.894 0L.19 12.767a.62.62 0 0 1 0-.894l5.477-5.477a.62.62 0 0 1 .894 0l.587.588a.62.62 0 0 1 0 .893L2.707 12.32zm21.298 0a.62.62 0 0 1-.19.447l-5.478 5.477a.62.62 0 0 1-.894 0l-.587-.587a.62.62 0 0 1 0-.894l4.443-4.443-4.443-4.443a.62.62 0 0 1 0-.894l.588-.588a.621.621 0 0 1 .893 0l5.477 5.478a.62.62 0 0 1 .191.447z'
      })
    )
  );
};
/*tslint:enable */
/*eslint-enable */

exports.default = Code;